import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 25,
        marginTop: 20
    },
    contentPrices: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 10
    },
    infoPrice: {
        fontSize: 14,
        fontWeight: 'bold'
    },
    hr: {
        height: 2,
        marginTop: 10,
        backgroundColor: "#2C2C2E",
        opacity: 0.5
    },
    textInfoPayment: {
        color: 'rgba(44, 44, 46, 0.5)',
        paddingHorizontal: 8,
        textAlign: 'center',
        marginTop: 15
    },
    infoNumberBankSplip: {
        color: '#000',
        paddingHorizontal: 8,
        textAlign: 'center',
        marginTop: 15,
        fontWeight: 'bold'
    },
    barCode: {
        color: '#000',
        paddingHorizontal: 8,
        textAlign: 'center',
        marginTop: 15,
        fontWeight: '400',
        fontSize: 18
    },
    contentBtn: {
        position: 'absolute',
        bottom: 50,
        paddingHorizontal: 25,
        width: '100%'
    },
    btn: {
        padding: 10,
        borderRadius: 20
    },
    textBtn: {
        color: '#fff',
        textAlign: 'center',
        fontSize: 18,
        fontWeight: '500'
    },
    contentSendEmail: {
        position: 'absolute',
        bottom: 110,
        paddingHorizontal: 25,
        width: '100%'
    },
    textSendEmail: {
        color: '#000',
        fontSize: 14,
        textDecorationLine: 'underline',
        textAlign: 'center'
    }
});

export default styles;
